import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';

class AutocompleteInput extends Component {
    constructor(props) {
        super(props);
        this.state = { 
			fullAutocompleteData: [],
			autocompleteData: [],
		}
    }

    onChange = (e) => {
		let value = e.target.value;
		this.props.handleCustomerAddress(e.target.value);

        const doGetAutocomplete = async (value) => {
            try {
                const autocompleteResponse = await getAutocomplete(value);
				console.log('autocompleteResponse: ', autocompleteResponse);
				const autocompleteData = autocompleteResponse.data.predictions.map((prediction) => {
					const myObject = {
						'label': prediction.description,
						'value': prediction.place_id,
					}
					return myObject;
				});
				this.setState({
					fullAutocompleteData: autocompleteResponse.data.predictions,
                    autocompleteData,
                });
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getAutocomplete(value) {
            return await ApiRequest('/google/place-search', {
                method: 'POST',
                data: {
                    input: `${value}`,
                }
            });
        }
		if (value.length >= 5) {
			doGetAutocomplete(value);
		}
	}
	
	onSelect = (value) => {
        const fullAutocompleteData = this.state.fullAutocompleteData;
		let place_id = '';
		fullAutocompleteData.forEach((data) => {
			if (data.place_id === value) {
				place_id = data.place_id;
			}
        });
        
        const doGetAddress = async (value) => {
            try {
                const addressResponse = await getAddress(value);
                console.log('addressResponse: ', addressResponse);

                const { customer } = this.props;
                const { validation } = this.props;
                customer['address_1'] = addressResponse.data.address;
                customer['city'] = addressResponse.data.city;
                customer['state'] = addressResponse.data.state;
                customer['country'] = addressResponse.data.country;
                customer['zip'] = addressResponse.data.zip;
                validation['customer']['address_1']['valid'] = true;
                validation['customer']['city']['valid'] = true;
                validation['customer']['state']['valid'] = true;
                validation['customer']['country']['valid'] = true;
                validation['customer']['zip']['valid'] = true;
                
                this.props.updateCustomerFromAutocompleteInput && this.props.updateCustomerFromAutocompleteInput(customer, validation);

                //this.props.handleFullCustomerAddress(addressResponse.data);
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getAddress(value) {
            return await ApiRequest('/google/place-detail', {
                method: 'POST',
                data: {
                    placeid: `${value}`,
                }
            });
        }
        doGetAddress(place_id);
	}

	renderItem = (item, isHighlighted) =>{
        return (
            <div className="item" style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>   
        ); 
	}
	
	getItemValue= (item) =>{
        return `${item.value}`;
    }

    componentDidMount() {
        
    }

    render() {
	  	return (
            <React.Fragment>
                <Autocomplete
                    autoComplete="address_1_new"
                    getItemValue={this.getItemValue}
                    items={this.state.autocompleteData}
                    renderItem={this.renderItem}
                    value={this.props.customer.address_1}
                    onChange={this.onChange}
                    onSelect={this.onSelect}
                    onBlur={this.props.validateRequiredField}
                    required 
                    menuStyle={{
                        background: '#fff',
                        padding: '0',
                        position: 'absolute',
                        top: '44px',
                        left: '0',
                        right: '0',
                        overflow: 'auto',
                        zIndex: '2',
                        maxHeight: '200px',
                    }}
                />
                {/*  <input
                    id="address_1"
                    className="showtix-input"
                    type="text"
                    object="customer"
                    name="address_1"
                    validation="(^(?!\s*$).+)"
                    value={this.props.customer.address_1}
                    onBlur={this.props.validateRequiredField}
                    onChange={this.props.handleCustomerInformation}
                    required
                    autoComplete="address_1_new"
                /> */}
            </React.Fragment>
	  	);
	}
}

export default AutocompleteInput;


// WEBPACK FOOTER //
// ./src/components/Common/AutocompleteInput/AutocompleteInput.js